import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface MenuItem {
  id: string;
  name: string;
  children?: MenuItem[];
  parentId?: string;
  level: number;
  label?: string;
  totalDocuments?: number;
}

interface InitialState {
  menuData: { data: MenuItem[]; status: ReduxStateType };
  subMenuData: {
    [key: string]: {
      data: MenuItem[];
      status: ReduxStateType;
      isOpen: boolean;
    };
  };

  subMenuCollapse: {
    [key: string]: {
      isOpen: boolean;
    };
  };
}

const initialState: InitialState = {
  menuData: {
    data: [],
    status: ReduxStateType.INIT,
  },
  subMenuData: {},
  subMenuCollapse: {},
};

const menuAuthorizationDocumentSlice = createSlice({
  name: "menuAuthorizationDocument",
  initialState,
  reducers: {
    getMenuADStart: (state) => {
      state.menuData.status = ReduxStateType.LOADING;
    },
    getMenuADSuccess: (state, action: PayloadAction<MenuItem[]>) => {
      state.menuData.status = ReduxStateType.SUCCESS;
      state.menuData.data = action.payload;
    },
    getMenuADFailed: (state) => {
      state.menuData.status = ReduxStateType.ERROR;
    },
    setIsOpenSubMenuAD: (
      state,
      action: PayloadAction<{ id: string; status: boolean }>
    ) => {
      state.subMenuData[action.payload.id] = {
        ...state.subMenuData[action.payload.id],
        isOpen: action.payload.status,
      };
    },

    setIsCollapseDataAD: (
      state,
      action: PayloadAction<{ id: string; status: boolean }>
    ) => {
      state.subMenuCollapse[action.payload.id] = {
        isOpen: action.payload.status,
      };
    },
    getSubMenuADStart: (state, action: PayloadAction<{ id: string }>) => {
      state.subMenuData[action.payload.id] = {
        status: ReduxStateType.LOADING,
        data: undefined,
        isOpen: false,
      };
    },
    getSubMenuADSuccess: (
      state,
      action: PayloadAction<{ id: string; data: MenuItem[] }>
    ) => {
      state.subMenuData[action.payload.id] = {
        status: ReduxStateType.SUCCESS,
        data: action.payload.data,
        isOpen: true,
      };
    },
    resetSubMenuAD: (state, action: PayloadAction<{ id: string }>) => {
      state.subMenuData[action.payload.id] = {
        status: ReduxStateType.INIT,
        data: [],
        isOpen: false,
      };
    },
    getSubMenuADFailed: (state, action: PayloadAction<{ id: string }>) => {
      state.subMenuData[action.payload.id] = {
        status: ReduxStateType.ERROR,
        data: undefined,
        isOpen: false,
      };
    },
    resetAuthorizationDocumentMenu: () => {
      return { ...initialState };
    },
  },
});

export const {
  getMenuADStart,
  getMenuADSuccess,
  getMenuADFailed,
  setIsOpenSubMenuAD,
  getSubMenuADStart,
  resetSubMenuAD,
  getSubMenuADSuccess,
  getSubMenuADFailed,
  setIsCollapseDataAD,
  resetAuthorizationDocumentMenu,
} = menuAuthorizationDocumentSlice.actions;

export default menuAuthorizationDocumentSlice.reducer;
